import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandlerThunk } from '../../App/App.thunk';
import { tagControlService } from './TagControl.service';
import { CreateTagDto, UpdateTagDto } from './TagControl.type';

const THUNK_PREFIX = 'tagControl';

export const getTagControlListThunk = createAsyncThunk(
  `${THUNK_PREFIX}/getTagControlListThunk`,
  async (params: { q?: string; page?: number | string; sort?: string }, thunkAPI) => {
    try {
      const response = await tagControlService.getList(params);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const createTagControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/createTagControlThunk`,
  async (tag: CreateTagDto, thunkAPI) => {
    try {
      const response = await tagControlService.create(tag);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const updateTagControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/updateTagControlThunk`,
  async (tag: UpdateTagDto, thunkAPI) => {
    try {
      const response = await tagControlService.update(tag);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const deleteTagControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/deleteTagControlThunk`,
  async (id: number, thunkAPI) => {
    try {
      await tagControlService.delete(id);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
